import { KatSpinner } from '@amzn/katal-react';
import React from 'react';
import * as ReactDOMClient from 'react-dom/client';
import { applyTheme } from '@amzn/awsui-components-core/theming';
import { StencilProvider } from '@amzn/stencil-react-components/context';
import defaultStencilTokens from '@amzn/stencil-design-tokens/js/web/theme/stencilTheme';
import { AgChartsEnterpriseModule } from 'ag-charts-enterprise';
import { ModuleRegistry, ValidationModule } from 'ag-grid-community';
import { AllEnterpriseModule } from 'ag-grid-enterprise';
import { APP_THEME, FONT_FAMILY_BASE } from './constants/ThemeConstants';
import AppInitWrapper from './app/AppInitWrapper';
import ENVIRONMENT_VARIABLES from './constants/environment-variables';

import { App } from './app/App';
import './index.scss';

// Mark the earliest point of JS execution for end-to-end page load measurement
performance.mark('xpt-page-load-start');

// Register all AG Grid modules and provide AG Charts for Integrated Charts and Sparklines.
ModuleRegistry.registerModules([AllEnterpriseModule.with(AgChartsEnterpriseModule)]);

// Register ValidationModule for dev builds only (excluded from AllEnterpriseModule since v36)
if (ENVIRONMENT_VARIABLES.env.Stage === 'dev') {
  ModuleRegistry.registerModules([ValidationModule]);
}

// Apply custom font to all Cloudscape components
applyTheme({ theme: APP_THEME });

// Override Stencil's default font (Amazon Ember) with Ember Modern Text to match Cloudscape theming
const STENCIL_THEME = {
  ...defaultStencilTokens,
  ':root': {
    ...defaultStencilTokens[':root'],
    '--st-dt-text-family-default': FONT_FAMILY_BASE
  }
};

const rootElement = document.getElementById('root');
if (rootElement) {
  const root = ReactDOMClient.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <StencilProvider theme={STENCIL_THEME}>
        <AppInitWrapper>
          <React.Suspense fallback={<KatSpinner size="large" />}>
            <App />
          </React.Suspense>
        </AppInitWrapper>
      </StencilProvider>
    </React.StrictMode>
  );
}
